export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["TRACE"] = "TRACE";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
export var IBatchStatus;
(function (IBatchStatus) {
    IBatchStatus["START"] = "START";
    IBatchStatus["STOP"] = "STOP";
})(IBatchStatus || (IBatchStatus = {}));
